<div class="row search-bar" style="justify-content: space-between">
  <div style="display: flex; flex: 1;">
    <div [ngClass]="{'col-md-3': !showFilter, 'col-lg-3 col-md-4 col-sm-4': showFilter}">
      <div class="form-group has-feedback input-group">
        <input (keyup.enter)="updateSearch()" [(ngModel)]="searchObj.search" type="text"
               class="form-control has-feedback has-clear" id="search"
               style="font-family: Helvetica, FontAwesome" placeholder="&#xF002; Search Permit Review">
        <i *ngIf="searchObj.search !== undefined && searchObj.search !== ''"
           (click)="searchObj.search = ''; updateSearch();"
           class="fa fa-times form-control-feedback"
           style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; margin-right: 40px; position: absolute;
    right: 4px;"></i>
        <span class="input-group-btn">
            <button type="button" class="btn btn-primary" (click)="updateSearch()">
                <i class="fa fa-search"></i>
            </button>
            </span>
      </div>
    </div>
    <div class="col-md-1" style="padding-top:6px; max-width: 0">
      <app-help-docs-links recordType="search" color="#333333"></app-help-docs-links>
    </div>
    <div class="col-lg-5 col-md-3 col-sm-2" style="
    max-width: 100%;
    flex: 1;
    padding-top: 0;
    align-items: flex-start;
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;" *ngIf="!loading">
      <div *ngFor="let activeFilter of activeFilters" class="btn btn-default" style="
      padding:1px 5px;
      margin-left: 2px;"
           (click)="clearFilter(activeFilter.type, activeFilter.value)" title="Clear this filter">
        <i class="fa fa-times"></i> {{ activeFilter.display }}
      </div>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-5 pull-right search-filter" ngbDropdown
        placement="bottom-end" #filterMenu="ngbDropdown"
       [(open)]="filter.isopen">
    <div *ngIf="!loading" class="dropdown" id="filterMenu">
      <div ngbDropdownToggle>
        <span><i class="fa fa-long-arrow-down"></i> Filter</span>
        <p style="color:#b8bcc0; white-space: nowrap;">Use filters to narrow your search</p>
      </div>
      <div ngbDropdownMenu>
        <ul id="filterMenuItems">
          <li>
            <app-help-docs-links recordType="filter" color="#000" class="pull-right"></app-help-docs-links>
          </li>
          <ng-container *ngIf="!searchObj.all_permits">
            <li>
              <div class="form-group" style="padding-right:10px">
                <label for="current_user"> Is Next:</label>
                <input type="checkbox" id="is_next" name="is_next"
                       [(ngModel)]="searchObj.is_next"
                       [checked]="searchObj.is_next" style="margin-left:5px">
              </div>
            </li>
          </ng-container>

          <li [hidden]="searchObj.all_permits">
            <div class="form-group" style="padding-right:10px">
              <label for="current_user"> Current User:</label>
              <input #current_user type="checkbox" id="current_user" name="current_user"
                     [(ngModel)]="searchObj.current_user"
                     [checked]="searchObj.current_user" style="margin-left:5px">
            </div>
          </li>
          <ng-container *ngIf="!current_user.checked">
            <li>
              <div class="form-group" style="padding-right:10px">
                <label>Reviewer:</label>
                <ng-container *ngIf="reviewService.meta.fields">
                  <select class="form-control" [(ngModel)]="searchObj.next_reviewer">
                    <ng-container
                        *ngIf="(reviewService.meta.fields.reviewer || (reviewService.meta.fields.reviewer | async)) as reviewer_meta">
                      <option *ngFor="let reviewer of reviewer_meta.choices"
                              [value]="reviewer.value">
                        {{ reviewer.display_name }}
                      </option>
                    </ng-container>
                  </select>
                </ng-container>

              </div>
            </li>
          </ng-container>
          <li>
            <div class="form-group" style="padding-right:10px">
              <label>Permit Type:</label>
              <select class="form-control" [(ngModel)]="searchObj.content_type" multiple>
                <option *ngFor="let contentType of typeChoices" [value]="contentType.value">
                  {{ contentType.display_name }}
                </option>
              </select>
            </div>
          </li>
          <li>
            <div class="form-group" style="padding-right:10px">
              <label>Permit Subtype:</label>
              <select class="form-control" [(ngModel)]="searchObj.sub_type" multiple>
                <option *ngFor="let subtype of subtypeChoices" [value]="subtype.value">
                  {{ subtype.display_name }}
                </option>
              </select>
            </div>
          </li>
          <li>
            <div class="form-group" style="padding-right:10px">
              <label>Permit Status:</label>
              <select class="form-control" [(ngModel)]="searchObj.current_status" multiple>
                <option *ngFor="let status of filteredStatus"
                        [value]="status.value">
                  {{ status.display_name }}
                </option>
              </select>
            </div>
          </li>
          <li>
            <div class="form-group" id="submitted_date_start" style="padding-right:10px">
              <label>Submission Date After (Start):</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #submitted_date="ngbDatepicker"
                       [(ngModel)]="searchObj.submission_date__gte" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="submitted_date.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
            </div>
          </li>
          <li>
            <div class="form-group" id="submitted_date_end" style="padding-right:10px">
              <label>Submission Date Before (End):</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #submitted_date_end="ngbDatepicker"
                       [(ngModel)]="searchObj.submission_date__lte" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="submitted_date_end.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
            </div>
          </li>
          <li>
            <div class="form-group" id="approved_date_start" style="padding-right:10px">
              <label>Approved Date After (Start):</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #approved_date="ngbDatepicker"
                       [(ngModel)]="searchObj.approved_date__gte" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="approved_date.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
            </div>
          </li>
          <li>
            <div class="form-group" id="approved_date_end" style="padding-right:10px">
              <label>Approved Date Before (End):</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #approved_date_end="ngbDatepicker"
                       [(ngModel)]="searchObj.approved_date__lte" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="approved_date_end.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
            </div>
          </li>
          <ng-container *ngIf="!searchObj.all_permits">
            <li>
              <div class="form-group" style="padding-right:10px">
                <label>Review Status:</label>
                <select class="form-control" [(ngModel)]="searchObj.status" multiple>
                  <option *ngFor="let status of filteredStatus"
                          [value]="status.value">
                    {{ status.display_name }}
                  </option>
                </select>
              </div>
            </li>
          </ng-container>
          <li style="display: flex; justify-content: space-between">
            <button type="button" class="btn btn-primary" id="filterButton"
                    (click)="updateFilter()">Apply
            </button>
            <button type="button" class="btn btn-secondary" id="clearFilter2"
                    (click)="clearFilters()">Clear Filter
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="panel-body" style="background:none;">
  <div class="row">
    <div class="col-md-12">
      <h3 *ngIf="!searchObj.all_permits" style="margin:10px 0">Review Queue</h3>
      <h3 *ngIf="searchObj.all_permits" style="margin:10px 0">Permit Queue</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <!--      <b>Total: </b>{{ reviewService.meta.count }}-->
      <ng-container *ngIf="loading==false">
        <b>Total: </b> {{ metaCount }}
      </ng-container>

      <!--      <span *ngIf="searchObj.current_user === true">(Total Permits Under Review {{ totalPermits }}.-->
      <!--        <a style="cursor: pointer; text-decoration: underline;" (click)="toggleAll()">View All</a>)</span>-->
      <!--      <span *ngIf="searchObj.current_user === false">-->
      <!--        (<a style="cursor: pointer; text-decoration: underline;" (click)="toggleAll()">View Only Permits Needing Your Review</a>)-->
      <!--      </span>-->
      <app-results-list (loadingResults)='loadingStatus($event)' (metaCountChange)="updateCount($event)"
                        [service]="reviewService" [displayFields]="displayFields" [showLink]="true" #resultsList
                        [(items)]="items" inputType="none" [(searchObj)]="searchObj"
                        [disableSort]="['current_status', 'current_reviewer', 'sub_type', 'content_type']"
                        [rowButtons]="rowButtons" [columnIcons]="columnIcons"
                        [getExtraStyling]="getRowColor"></app-results-list>
    </div>
  </div>
</div>
